import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"
import { Menu } from "semantic-ui-react"

const Container = styled.div`
  width: 100%;
`

const StyledMenu = styled(Menu)`
  margin-bottom: 32px !important;
  display: none !important;

  @media ${device.tablet} {
    display: flex !important;
  }
`

function MobileSearch() {
  const { state, dispatch } = useContext(FilterContext)

  const highlightWords = input => {
    dispatch({ searchInput: input })
  }

  useEffect(() => {
    const productTitle = document.querySelectorAll(".product-title")
    const reg = new RegExp(state.searchInput, "gi")

    if (productTitle?.length) {
      productTitle.forEach((title, key) => {
        if (title.innerText.match(reg)) {
          title.innerHTML = title.innerText.replace(
            reg,
            match => `<mark>${match}</mark>`
          )
        }
      })
    }
  }, [state.filteredProducts, state.searchInput])

  return (
    <StyledMenu>
      <Container className="ui aligned category search item">
        <div className="ui transparent icon input">
          <input
            value={state.searchInput}
            onChange={e => highlightWords(e.target.value.toLowerCase())}
            className="prompt"
            type="text"
            placeholder="Søg efter tøj"
          />
          {state.searchInput ? (
            <i
              role="button"
              onClick={() => highlightWords("")}
              className="close link icon"
            />
          ) : (
            <i className="search link icon" />
          )}
        </div>
        <div className="results" />
      </Container>
    </StyledMenu>
  )
}

export default MobileSearch
